export default __webpack_public_path__ + "static/media/appleStore.29b4e85e.svg";